import * as actionTypes from './actionTypes';

const initialState = {
    allData: [],
    history: [],
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.UPDATE_EXAM_SCHEDULE:
            state = {
                ...state,
                allData: action.payload.data,
            }
            break;
        case actionTypes.UPDATE_EXAM_SCHEDULE_HISTORY:
            state = {
                ...state,
                history: action.payload.data,
            }
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default reducer;
